export default __webpack_public_path__ + "static/media/Junction@POS.08a0cb6c.png";